import React from 'react'
import './PromoBar.css'

const PromoBar = () => {
  return (
    <div className='promobar'>
        <p>15% OFF orders over $75! Use code: SAVE15</p>
    </div>
  )
}

export default PromoBar